import { constructEncodedSearchQueryString } from 'util/search'

export function pathFor(searchObject) {
  const string = constructEncodedSearchQueryString(searchObject)
  return `/search/${string}`
}
